<app-header></app-header>
<app-overview id="overview"></app-overview>

<app-infos id="infos"></app-infos>
<!-- <app-pricing id="pricing"></app-pricing> -->
<app-map id="map"></app-map>
<app-carousel id="pictures"></app-carousel>
<app-calltoaction id="registration"></app-calltoaction>
<app-footer></app-footer>
